import React from "react";
import styled from "styled-components";
import Axis from "./Axis";

const Group = styled.g`
  text {
    display: none;
  }

  line,
  path {
    fill: none;
    stroke: #1b567a;
    stroke-width: 1px;
    stroke-dasharray: 1.5 2;
  }

  @media (min-width: 1800px) {
    line-break,
    path {
      stroke-width: 2px;
      stroke-dasharray: 2.55 3.39;
    }
  }

  @media (max-width: 575px) {
    line-break,
    path {
      stroke-width: 1px;
      stroke-dasharray: 2.55 3.39;
    }
  }
`;

const Text = styled.text`
  fill: ${props => props.theme.text};
  font-size: 15px;
  @media (max-width: 575px) {
    font-size: 18px;
  }

  @media (min-width: 1800px) {
    font-size: 20px;
  }
`;

const Axes = ({ width, scale, marginTop, x, y, counts }) => {
  const stepWidth = width / 5;

  const topProps = {
    orient: "Bottom",
    scale: scale,
    translate: `translate(${x}, ${marginTop})`,
    tickSize: 20
  };

  const midTopProps = {
    orient: "Bottom",
    scale: scale,
    translate: `translate(${x}, ${y})`,
    tickSize: 10
  };

  const midBottomProps = {
    orient: "Top",
    scale: scale,
    translate: `translate(${x}, ${y})`,
    tickSize: 10,
    tickFormat: ""
  };

  return (
    <>
      <Group className="axes">
        <Axis {...topProps} />
        <Axis {...midTopProps} />
        <Axis {...midBottomProps} />
      </Group>
      <g className="axisCounts">
        {counts.map((count, i) => (
          <Text
            key={i}
            x={x + (stepWidth / 2 + i * stepWidth)}
            y={marginTop + 25}
            textAnchor="middle"
            dominantBaseline="central"
          >
            {count}
          </Text>
        ))}
      </g>
    </>
  );
};
export default Axes;
